import { render, staticRenderFns } from "./ref-data.vue?vue&type=template&id=5c9ea6e0&scoped=true&"
import script from "./ref-data.vue?vue&type=script&lang=ts&"
export * from "./ref-data.vue?vue&type=script&lang=ts&"
import style0 from "./ref-data.vue?vue&type=style&index=0&id=5c9ea6e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ea6e0",
  null
  
)

export default component.exports